<template>
  <div>
    <headerSection></headerSection>

    <div id="main__content" class="rewards-page">
      <!-- Hero Section -->
      <div class="hero-section">
        <!-- Floating Balls -->
        <div class="floating-ball ball-1"></div>
        <div class="floating-ball ball-2"></div>
        <div class="floating-ball ball-3"></div>

        <div class="container">
          <div class="hero-content">
            <!-- Trophy Icon -->
            <div class="hero-icon-wrapper">
              <span class="hero-icon">🏆</span>
            </div>

            <!-- Title -->
            <h1 class="title-glow">{{ $t('rewards_page.title') }}</h1>

            <!-- Description -->
            <p class="hero-description" v-html="rewardDescription"></p>

            <!-- User Points Display -->
            <div class="points-display" v-if="user && user.coin">
              <div class="points-card">
                <span class="points-label">{{ $t('rewards_page.your_points') }}</span>
                <div class="points-value">
                  <span class="points-icon">⭐</span>
                  <span class="points-number">{{ user.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Rewards Grid -->
      <div class="container rewards-container">
        <div class="rewards-grid">
          <div
            v-for="(item,index) in rewards"
            :key="index"
            class="reward-card"
            :class="{ 'locked': checkLocked(item) }"
            @click="conFirmRedeem(item)"
          >
            <div class="reward-image-wrapper">
              <img
                class="reward-image"
                :alt="item.name"
                :src="item.image"
                width="200"
                height="200"
              >
            </div>

            <div class="lock-overlay" v-if="checkLocked(item)">
              <div class="lock-icon">🔒</div>
              <div class="lock-text">{{ $t('rewards_page.locked_message') }}</div>
            </div>
          </div>
        </div>

        <!-- Footer Info -->
        <div class="footer-info">
          <div class="info-card">
            <h2 class="info-title">
              <a href="https://connextcc.com">ConnextCC</a>&nbsp;{{ $t('rewards_page.subtitle') }}
            </h2>
            <p class="info-description">
              {{ $t('rewards_page.footer_description') }}
            </p>
          </div>
        </div>
      </div>

      <footerSection></footerSection>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
const axios = require('axios').default
export default {
  name: 'Home',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  mounted () {
    const width = screen.width
    if(width <= 480)
      this.backgroundImage = require('../assets/images/Shiba-BG1.jpg')
    else
      this.backgroundImage = require('../assets/images/Shiba-BG1.jpg')
    this.$store.dispatch('user/getRewards').catch(err => { console.error(err) })
    this.loadRewardDescription()
  },
  data () {
    return {
      continueCheck: false,
      receiveAnounceMent: false,
      anoucement: {},
      balance: 0,
      fa_spin: false,
      backgroundImage: '',
      disabled: false,
      rewardDescriptions: null
    }
  },
  computed: {
    sites_credit () {
      return this.$store.state.user.sites_credit
    },
    user () {
      return this.$store.state.user.user
    },
    rewards () {
      return this.$store.state.user.rewards
    },
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    },
    rewardDescription () {
      const locale = this.$i18n ? this.$i18n.locale : 'th'
      if (this.rewardDescriptions && this.rewardDescriptions[locale] && this.rewardDescriptions[locale].trim() !== '') {
        return this.rewardDescriptions[locale]
      }
      return this.$t('rewards_page.description')
    }
  },
  methods: {
    checkLocked (item) {
      return (!this.user || !this.user.key || !this.user.coin || Number(this.user.coin) < item.point)
    },
    checkStyle (item) {
      if ((!this.user || !this.user.key || !this.user.coin || Number(this.user.coin) < item.point)) {
        return 'border-radius:0px;-webkit-filter: grayscale(100%);filter: grayscale(100%);'
      }
    },
    async conFirmRedeem (item) {
      // ป้องกันการคลิกถ้า locked
      if (this.checkLocked(item)) {
        return
      }

      if (!this.disabled) {
        this.disabled = true
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally(() => {
          this.$store.commit('user/SET_LOADING', false)
          if (this.user.coin && Number(this.user.coin) >= Number(item.point)) {
            this.$confirm(
              {
                message: this.getRedeemMessage(item),
                button: {
                  yes: this.$t('rewards_page.confirm'),
                  no: this.$t('rewards_page.cancel')
                },
                callback: confirm => {
                  if (confirm) {
                    this.$store.commit('user/SET_LOADING', true)
                    setTimeout(() => {
                      firebase.firestore().collection('redeem').add({
                        userkey: this.user.key,
                        code: this.user.code,
                        reward: item.key,
                        type: item.type,
                        credit: (item.credit) ? item.credit : '',
                        point: item.point,
                        status: false,
                        createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                      }).then((result) => {
                        axios({
                          method: 'post',
                          url: 'https://api.connextcc.cc/qmovetowallet/redeem',
                          data: {
                            code: this.user.code,
                            key: result.id
                          }
                        })
                        this.$store.commit('user/SET_LOADING', false)
                      })
                    }, Math.floor(Math.random() * 3000))
                  }
                }
              }
            )
          }
        }).catch(err => { console.error(err) })
        setTimeout(() => {
          this.disabled = false
        }, 2000)
      }
    },
    getRedeemMessage (item) {
      const locale = this.$i18n ? this.$i18n.locale : 'th'
      if (locale === 'en') {
        return `Do you want to redeem ${item.name}?`
      }
      if (locale === 'my') {
        return `${item.name} ကို လဲလှယ်လိုပါသလား?`
      }
      return `ต้องการใช้เหรียญ ${item.name} แลกรางวัลนี้ใช่หรือไม่`
    },
    async loadRewardDescription () {
      try {
        const snapshot = await firebase.database().ref('/condition/rewardDescription').once('value')
        if (snapshot.val()) this.rewardDescriptions = snapshot.val()
      } catch (e) { console.error(e) }
    },
    async redeem (item) {
      if (!(!this.user || !this.user.key || !this.user.coin || Number(this.user.coin) < item.point)) {
        this.conFirmRedeem(item)
      }
    }
  }
}
</script>

<style scoped>
/* ===== Page Base ===== */
.rewards-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #2b2727 0%, #1b1b1b 50%, #2b2727 100%);
  padding-bottom: 100px;
}

/* ===== Hero Section ===== */
.hero-section {
  position: relative;
  padding: 80px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(247, 178, 66, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 0;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ===== Trophy Icon ===== */
.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(247, 178, 66, 0.4));
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* ===== Title & Description ===== */
.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  text-shadow:
    0 0 20px rgba(247, 178, 66, 0.5),
    0 0 40px rgba(247, 178, 66, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: 30px;
}

/* ===== Floating Balls ===== */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #f7b242, #ce840c);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #ce840c, #f7b242);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #2b2727, #f7b242);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* ===== Points Display ===== */
.points-display {
  margin-top: 30px;
}

.points-card {
  background: linear-gradient(135deg, rgba(247, 178, 66, 0.2), rgba(206, 132, 12, 0.2));
  backdrop-filter: blur(10px);
  border: 2px solid rgba(247, 178, 66, 0.4);
  border-radius: 15px;
  padding: 20px 30px;
  display: inline-block;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(247, 178, 66, 0.2);
}

.points-label {
  display: block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.points-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.points-icon {
  font-size: 28px;
}

.points-number {
  font-size: 40px;
  font-weight: 700;
  color: #f7b242;
  text-shadow: 0 0 20px rgba(247, 178, 66, 0.5);
}

/* ===== Rewards Container ===== */
.rewards-container {
  padding: 40px 20px;
}

/* ===== Rewards Grid ===== */
.rewards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.reward-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.2);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
}

.reward-card:hover {
  transform: translateY(-5px);
  border-color: rgba(247, 178, 66, 0.4);
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.4),
    0 0 30px rgba(247, 178, 66, 0.2);
}

.reward-card.locked {
  filter: grayscale(100%);
  opacity: 0.6;
  cursor: not-allowed;
}

.reward-card.locked:hover {
  transform: none;
}

.reward-image-wrapper {
  width: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reward-image {
  width: 100%;
  height: auto;
  max-width: 200px;
  display: block;
}

/* ===== Lock Overlay ===== */
.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.lock-icon {
  font-size: 48px;
  margin-bottom: 10px;
  animation: shake 0.5s ease-in-out infinite alternate;
}

@keyframes shake {
  0% { transform: rotate(-5deg); }
  100% { transform: rotate(5deg); }
}

.lock-text {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

/* ===== Footer Info ===== */
.footer-info {
  margin-top: 40px;
}

.info-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.2);
  border-radius: 12px;
  padding: 30px;
  text-align: center;
}

.info-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
}

.info-title a {
  color: #f7b242;
  text-decoration: none;
  transition: all 0.3s ease;
}

.info-title a:hover {
  color: #ce840c;
  text-shadow: 0 0 10px rgba(247, 178, 66, 0.5);
}

.info-description {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin: 0;
}

/* ===== Responsive ===== */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 25px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .rewards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .points-card {
    padding: 15px 25px;
  }

  .points-number {
    font-size: 32px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .info-title {
    font-size: 20px;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-description {
    font-size: 14px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .points-card {
    padding: 12px 20px;
  }

  .points-number {
    font-size: 28px;
  }

  .points-icon {
    font-size: 24px;
  }

  .info-card {
    padding: 20px;
  }

  .info-title {
    font-size: 18px;
  }

  .info-description {
    font-size: 14px;
  }

  .lock-icon {
    font-size: 36px;
  }

  .lock-text {
    font-size: 12px;
  }
}
</style>
